import Input from "@/components/core/Input/Input"
import { apim } from "@/constants/api"
import { validateEmail } from "@/js/helperV2"
import { useEffect, useState } from "react"
import { getAnalyticsData } from "../AddToCart/analytics"
import Button from "@/components/core/Button/Button"
import { validNumber, validPincode } from "@/utils/validate"
import { selectAuthState } from "@/store/features/authSlice"
import { useSelector } from "react-redux"

const NotifyComponent = props => {
  const {
    staticTexts,
    setNotifySuccess,
    productAnalyticsData,
    productInRiverId_s,
    sku,
    fromAddToCart = false,
    notifyContainer,
    notifyClicked = false,
    productCategory = "",
    imagesData,
  } = props
  const getCookieValue = name =>
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""
  const initState = { email: "", pincode: getCookieValue("pincode") }
  const [notifyMeFormData, setNotifyFormData] = useState(initState)
  const [notifyMeErrors, setNotifyFormErrors] = useState({})
  const { isAuth, user } = useSelector(selectAuthState)
  const handleFieldChange = (
    val = "",
    fieldName = "",
    data = {},
    setData = () => {}
  ) => {
    const inputValue = val.trimStart()
    if (inputValue === "") {
      setData({
        ...data,
        [fieldName]: inputValue,
      })
    } else if (fieldName === "email") {
      setData({
        ...data,
        [fieldName]: inputValue.trim(),
      })
    } else if (fieldName === "pincode") {
      if (validNumber(inputValue) && inputValue.length <= 6) {
        setData({
          ...data,
          [fieldName]: inputValue,
        })
      }
    }
  }
  useEffect(() => {
    if (notifyClicked) handleNotification()
  }, [notifyClicked])
  const handleFieldBlur = (
    val = "",
    fieldName = "",
    errors,
    setError = () => {}
  ) => {
    const inputValue = val.trimStart()
    const { validEmail, validPincode } = staticTexts
    if (fieldName === "email") {
      if (!validateEmail(inputValue)) {
        setError({
          ...errors,
          [fieldName]: validEmail,
        })
      }
    } else if (fieldName === "pincode") {
      if (inputValue.length < 6) {
        setError({
          ...errors,
          [fieldName]: validPincode,
        })
      }
    }
  }

  const onFieldChange = e => {
    const { name = "", value = "" } = e.target
    handleFieldChange(value, name, notifyMeFormData, setNotifyFormData)
    setNotifyFormErrors({ ...notifyMeErrors, [name]: "" })
  }

  const onFieldBlur = e => {
    const { name = "", value = "" } = e.target
    handleFieldBlur(value, name, notifyMeErrors, setNotifyFormErrors)
  }

  const handleNotification = () => {
    const { email, pincode } = notifyMeFormData
    let { price, name: skuName, desc: skuDescription } = props
    let isValid = Object?.values(notifyMeErrors)?.every(
      el => el === null || el === "" || el === undefined
    )
    let error = {}
    if (email === "") {
      error = {
        ...error,
        email: "Please enter a valid email address.",
      }
      isValid = false
    }
    if (pincode === "") {
      error = {
        ...error,
        pincode: "Please enter a valid Pin code.",
      }
      isValid = false
    }
    setNotifyFormErrors(error)
    if (!skuName || !skuDescription) {
      const { productAnalyticsData } = props
      skuName = productAnalyticsData.name
      skuDescription = productAnalyticsData.desc
    }
    if (isValid) {
      const assetId = imagesData[0].assetId
      const isMissingImage = assetId.includes("image-missing")
      const body = {
        mastervariantkey: productInRiverId_s,
        sku: sku,
        skuName: skuName,
        skuDescription: skuDescription,
        skuPrice: `${price}`,
        customer: {
          email: email,
          ...(isAuth && { phone: user.login }),
        },
        pincode: pincode,
        qty: "1",
        pdpUrl: window.location.href,
        category: productCategory,
        skuImageUrl: !isMissingImage ? imagesData[0].url : "",
      }

      apim
        .post("catalog/product/oos/notify", body)
        .then(res => {
          if (res) {
            setNotifySuccess(true)
          }
        })
        .catch(error => {})
    }
  }

  const checkDisabled = data => {
    const { email, pincode } = data
    return !(validateEmail(email) && validPincode(pincode))
  }

  return (
    <>
      {!fromAddToCart ? (
        <div className="notify-text">{staticTexts.notifyEmailOosTxt}</div>
      ) : null}
      <div className="notify-email notify-email__out-of-stock">
        <div className="notify-email__input">
          <Input
            id="email"
            name="email"
            ariaRequried={true}
            type="text"
            maxLength={60}
            value={notifyMeFormData?.email}
            label={`${staticTexts.emailAddress}*`}
            onChange={onFieldChange}
            showError={notifyMeErrors?.email}
            onBlur={onFieldBlur}
            errorMessage={notifyMeErrors?.email}
          />
        </div>
        <div className="notify-email__input">
          <Input
            id="pincode"
            name="pincode"
            ariaRequried={true}
            type="text"
            maxLength={60}
            value={notifyMeFormData?.pincode}
            label={staticTexts.pincode}
            onChange={onFieldChange}
            showError={notifyMeErrors?.pincode}
            onBlur={onFieldBlur}
            errorMessage={notifyMeErrors?.pincode}
          />
        </div>
        <div className="notify-btn">
          <Button
            className="gbh-data-layer"
            data-gbh-data-layer={getAnalyticsData(staticTexts.notifyMailCTA)}
            data-gbh-data-layer-custom={productAnalyticsData.stringProductInfo}
            label={staticTexts.notifyMailCTA}
            onClick={handleNotification}
            size="large"
            type="primary"
            role="button"
            flexible={true}
            disabled={false}
            ref={notifyContainer}
          />
        </div>
      </div>
    </>
  )
}
export default NotifyComponent
